import {
  Flex,
  HStack,
  Image,
  Stack,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react";

import { useEffect } from "react";
import { Typewriter } from "react-simple-typewriter";
import Tilt from "react-parallax-tilt";

import hero from "../images/sufiPic.png";
import hero2 from "../images/sufiPic2.png";

import Aos from "aos";
import "aos/dist/aos.css";

const Hero = () => {
  useEffect(() => {
    Aos.init({
      duration: 600,
      once: true,
    });
  }, []);

  const bg = useColorModeValue(
    "linear-gradient(3deg, rgba(216,241,255,1) 0%, rgba(175,188,255,0) 100%)",
    "linear-gradient(221deg, rgba(14,4,4,1) 0%, rgba(61,61,61,1) 51%, rgba(64,64,64,1) 60%, rgba(55,55,55,1) 70%, rgba(14,4,4,1) 100%)"
  );

  const HeroImage = useColorModeValue(hero, hero2);

  const MainFont = useColorModeValue(
    "#302e4c",
    "linear(to-b, #ffdda1, #b07844)"
  );

  const txtWriter = useColorModeValue("#e53e3e", "white");

  return (
    <Stack
      position="relative"
      id="home"
      p={{ base: 0, md: 8 }}
      w="full"
      bg={bg}
    >
      <Stack
        data-aos="zoom-in"
        justifyContent={{ base: "space-around", sm: "space-around" }}
        alignItems="center"
        p={{ base: 0, sm: 8 }}
        alignSelf="center"
        justify="center"
        w="full"
        maxW="1400px"
        h={{ base: "90vh", sm: "80vh", md: "90vh" }}
        flexFlow={{ base: "column-reverse", lg: "row" }}
        flexDirection={{ base: "column", lg: "row" }}
      >
        <Flex
          marginTop={{ base: "-50px", sm: "0px" }}
          w={{ base: "90%", sm: "500px", md: "600px" }}
          flexDirection="column"
          h="fit-content"
          alignItems={{ base: "center", lg: "flex-start" }}
          p={5}
          spacing={{ base: 1, md: 5 }}
        >
          <Text fontSize={{ base: "18px", sm: "2xl" }} fontWeight="m">
            Welcome to my world ... I'm
          </Text>
          <Tilt>
            <Text
              fontWeight="semibold"
              bg={MainFont}
              bgGradient={MainFont}
              bgClip="text"
              fontSize={{ base: "3xl", sm: "4xl", md: "4xl", lg: "6xl" }}
            >
              Sufiyan Shaikh
            </Text>
          </Tilt>
          <Text
            fontSize={{ base: "18px", sm: "2xl", md: "xl", lg: "3xl" }}
            fontWeight="semibold"
          >
            <Text color={txtWriter}>
              {/* Style will be inherited from the parent element */}
              <Typewriter
                words={[
                  "Full Stack Developer",
                  "Problem Solver",
                  "Fast Learner",
                  "React Enthusiastic",
                  "Team Player",
                ]}
                loop={500000}
                cursor
                cursorStyle="|"
                typeSpeed={90}
                deleteSpeed={70}
                delaySpeed={2000}
              />
            </Text>
          </Text>

          <HStack alignItems="center"></HStack>
        </Flex>

        <VStack
          boxSize={{ base: "100%", sm: "400px", md: "450px" }}
          h="fit-content"
          alignItems="flex-start"
          p={{ base: 8, md: 5 }}
        >
          <Tilt>
            <Image
              data-aos="zoom-in"
              marginTop={{ base: "35px", sm: "0px", xl: "-45px" }}
              w="full"
              src={HeroImage}
            />
          </Tilt>
        </VStack>
      </Stack>
    </Stack>
  );
};

export default Hero;
